import {mediaStrings as MEDIA_STRINGS} from '@wandb/weave/common/types/media';
import memoize from 'memoize-one';

import {type RunHistoryKeyInfo} from '../../../types/run';
import {dominantKeyType} from '../../../util/runhelpers';
import {type KeyTypes} from '../common';

const MEDIA_STRINGS_SET = new Set<string>(MEDIA_STRINGS);

function getMediaKeysImpl(keyInfo: RunHistoryKeyInfo): {
  allMediaKeys: string[];
  defaultKeys: string[] | undefined;
  keyTypes: KeyTypes;
  numericKeys: string[];
} {
  const keys = keyInfo.keys;
  const keyTypes: KeyTypes = {};
  const allMediaKeys: string[] = [];
  const numericKeys: string[] = [];

  // Single pass over the history keys to classify each one, rather than
  // building the full type map and then re-scanning it (with lodash) once per
  // type. The key set can be very large (100k+), so the extra passes are costly.
  for (const key of Object.keys(keys)) {
    const type = dominantKeyType(keys[key].typeCounts);
    if (type === undefined) {
      continue;
    }
    keyTypes[key] = type;
    if (MEDIA_STRINGS_SET.has(type)) {
      allMediaKeys.push(key);
    } else if (type === 'number') {
      numericKeys.push(key);
    }
  }

  const defaultKeys = allMediaKeys.length > 0 ? [allMediaKeys[0]] : undefined;

  return {
    allMediaKeys,
    defaultKeys,
    keyTypes,
    numericKeys,
  };
}

export const getMediaKeys = memoize(getMediaKeysImpl);

export function getMediaKeysDisplayStringParts(mediaKeys: string[]): {
  type: 'element' | 'literal';
  value: string;
}[] {
  // casting to `any` avoids the ts(2339) error for ListFormat not existing on Intl
  // likely can be removed if we upgrade to a more recent target version
  const formatter = new (Intl as any).ListFormat('en', {
    style: 'long',
    type: 'conjunction',
  });
  return formatter.formatToParts(mediaKeys);
}
